export default __webpack_public_path__ + "static/media/store-icon.9c5180b4.svg";